import React, { useState, useEffect } from 'react';

// Format price based on value: 6 significant digits for $10 and under, 2 decimal places for over $10
const formatPrice = (price) => {
  if (price == null || isNaN(price)) return '0.00';
  if (price > 10) {
    return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else {
    return price.toLocaleString('en-US', { maximumSignificantDigits: 6 });
  }
};

function OrderBook({ coinId }) {
  const [asks, setAsks] = useState([]);
  const [bids, setBids] = useState([]);
  const [spread, setSpread] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (coinId) {
      fetchOrderBook();
      // Refresh order book every 1 second
      const interval = setInterval(fetchOrderBook, 1000);
      return () => clearInterval(interval);
    }
  }, [coinId]);

  const fetchOrderBook = async () => {
    if (!coinId) return;

    // Only show loading state if we don't have data yet
    if (asks.length === 0 && bids.length === 0) {
      setLoading(true);
    }

    try {
      const response = await fetch(`/api/crypto/orderbook/${coinId}?limit=15`);
      const result = await response.json();

      if (result.success) {
        setAsks(result.data.asks.slice(0, 15).reverse()); // Show asks in descending order
        setBids(result.data.bids.slice(0, 15));

        // Calculate spread
        if (result.data.asks.length > 0 && result.data.bids.length > 0) {
          const bestAsk = result.data.asks[0].price;
          const bestBid = result.data.bids[0].price;
          setSpread(formatPrice(bestAsk - bestBid));
        }
      }
    } catch (error) {
      console.error('Error fetching order book:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="order-book">
      <h3>Order Book</h3>

      <div className="order-book-header">
        <span>Market Size</span>
        <span>Price (USD)</span>
        <span>My Size</span>
      </div>

      {/* Asks (Sell orders) - Red */}
      <div className="asks">
        {loading && asks.length === 0 ? (
          <div className="loading">Loading...</div>
        ) : asks.length > 0 ? (
          asks.map((order, idx) => (
            <div key={idx} className="order-row ask">
              <span className="size">{order.size.toFixed(4)}</span>
              <span className="price">{formatPrice(order.price)}</span>
              <span className="my-size">-</span>
            </div>
          ))
        ) : (
          <div className="no-data">No asks</div>
        )}
      </div>

      {/* Spread indicator */}
      <div className="spread">
        <span>USD Spread</span>
        <span className="spread-value">{spread}</span>
      </div>

      {/* Bids (Buy orders) - Green */}
      <div className="bids">
        {loading && bids.length === 0 ? (
          <div className="loading">Loading...</div>
        ) : bids.length > 0 ? (
          bids.map((order, idx) => (
            <div key={idx} className="order-row bid">
              <span className="size">{order.size.toFixed(4)}</span>
              <span className="price">{formatPrice(order.price)}</span>
              <span className="my-size">-</span>
            </div>
          ))
        ) : (
          <div className="no-data">No bids</div>
        )}
      </div>

    </div>
  );
}

export default OrderBook;
